import styled from 'styled-components';
import { ApButtonMain } from '@alixpartners/ui-components';

export const PageWrapper = styled.div`
  padding: 24px;
  background-color: #f1f1f1;
  min-height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const PageTitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PageTitle = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 19px;
  line-height: 20px;
  color: #000000;
`;

export const PageSubtitle = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: rgba(0, 0, 0, 0.87);
`;

export const ContentRow = styled.div`
  display: flex;
  gap: 24px;
  flex: 1;
`;

export const SidebarCard = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  padding: 24px;
  width: 240px;
  box-sizing: border-box;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SidebarTitle = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 17px;
  line-height: normal;
  color: #28292c;
`;

export const SidebarList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SidebarItem = styled.div<{ isSelected?: boolean }>`
  height: 32px;
  display: flex;
  align-items: center;
  padding: 0 4px;
  border-radius: 4px;
  cursor: pointer;
  background-color: ${({ isSelected }) => (isSelected ? '#dff0db' : '#ffffff')};
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 1;
  color: #4a4a4a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const MainCard = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  padding: 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const MainCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 32px;
`;

export const SectionTitle = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 17px;
  line-height: normal;
  color: #1a1a1a;
`;

export const TableWrapper = styled.div`
  border: 1px solid #e4e4e4;
  display: flex;
  flex-direction: column;
  overflow-x: auto;
`;

export const TableHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background-color: #ffffff;
`;

export const ColHeader = styled.div<{
  width?: number;
  alignRight?: boolean;
  fillWidth?: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: #737373;
  white-space: nowrap;
  ${({ fillWidth }) => fillWidth && 'flex: 1; min-width: 0;'}
  ${({ fillWidth, width }) =>
    !fillWidth && width != null
      ? `width: ${width}px; flex-shrink: 0; min-width: 0;`
      : ''}
  ${({ alignRight }) => alignRight && 'justify-content: flex-end;'}
`;

export const TableRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background-color: #ffffff;
  filter: drop-shadow(0px -1px 0px #cccccc);
`;

export const FileNameCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 248px;
  flex-shrink: 0;
  overflow: hidden;
`;

export const FileIconContainer = styled.div`
  width: 32px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f1f1f1;
  border-radius: 4px;
  flex-shrink: 0;
`;

export const ReportLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: #0369a3;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
`;

export const CellText = styled.div<{ width?: string }>`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: #1a1a1a;
  width: ${({ width }) => width || 'auto'};
  flex-shrink: 0;
`;

export const ActionsCell = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  width: 264px;
  flex-shrink: 0;
`;

export const ShareToggleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ShareToggleLabel = styled.span`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1;
  color: #4a4a4a;
  white-space: nowrap;
`;

export const RowActionDivider = styled.div`
  width: 1px;
  height: 20px;
  background-color: #cccccc;
  flex-shrink: 0;
`;

export const TableLoadingRow = styled.div`
  padding: 16px;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.87);
  background-color: #ffffff;
  box-shadow: 0px -1px 0px #cccccc;
`;

export const TableEmptyRow = styled(TableLoadingRow)``;

export const ActionDivider = styled.div`
  width: 1px;
  height: 32px;
  background-color: #c4c4c4;
`;

export const BuildSection = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #cccccc;

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

export const BuildSectionText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

export const BuildSectionHeading = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 17px;
  line-height: normal;
  color: #1a1a1a;
`;

export const BuildSectionBody = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: rgba(0, 0, 0, 0.87);
`;

export const BuildSectionMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const BuildMetaLabel = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: rgba(0, 0, 0, 0.87);
`;

export const BuildMetaValue = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  color: #0369a3;
`;

export const BuildLink = styled.a`
  color: #0369a3;
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
`;

export const BuildContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const TertiaryButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 13px;
  letter-spacing: 0.26px;
  color: #4a4a4a;
  white-space: nowrap;

  &:disabled {
    cursor: default;
    opacity: 0.4;
  }
`;

export const RowIconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
`;

export const ViewReportsButton = styled(ApButtonMain)`
  && span {
    font-size: 15px;
    letter-spacing: 0.3px;
  }
`;
